import React from 'react';
import { useTilt } from '../hooks/useTilt';
import { usePressSpring } from '../hooks/usePressSpring';
import { mergeRefs } from '../utils/mergeRefs';
import { cx } from '../utils/cx';
import mixins from '../styles/mixins.module.css';

// Liquid-glass surface: pointer-tracked highlight, optional 3D tilt and
// press-spring feedback. Composes the shared `.glass`/`.spring` mixins
// rather than relying on any bare global selector.
function GlassCard(
  { as = 'div', tilt = false, press = false, className, children, ...rest },
  ref
) {
  const Tag = as;
  const tiltRef = useTilt({ tilt });
  const pressRef = usePressSpring(press ? mixins.pressed : null);

  return (
    <Tag
      ref={mergeRefs(ref, tiltRef, pressRef)}
      className={cx(mixins.glass, mixins.spring, className)}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default React.forwardRef(GlassCard);
